import * as React from 'react';
import { InfoWindow, Marker } from '@react-google-maps/api';
import { Instance } from 'mobx-state-tree';
import { NavLink } from 'react-router-dom';
import { Page, TLCode } from '../../common/enums';
import TranslatedMessage from './translation/TranslatedMessage';
import { Button } from '@blueprintjs/core';
import styled from '@emotion/styled';
import { Pharmacy } from '../../store/models/Pharmacy';
import { IconNames } from '@blueprintjs/icons';
import SimplePharmacyCalendar from './SimplePharmacyCalendar';
import moment from 'moment';
import { Group } from '../../store/models/Group';

export interface PharmacyMarkerProps {
  marker: Instance<typeof Pharmacy>;
  icon: any;
  zIndex?: number;
  onSelectionClick?: (pharmacy: Instance<typeof Pharmacy>) => void;
  // onAssignClick?: (dutyAssignmentId: number, pharmacyId: number, type: string) => void;
  onUnassignClick?: (dutyAssignmentId: number, pharmacyId: number) => void;
  isFree?: (pharmacyId: number) => boolean;
  isDayOnly?: (pharmacyId: number) => boolean;
  isDayAndNight?: (pharmacyId: number) => boolean;
  onAddDayOnlyClick?: (date: string, pharmacyId: number) => void;
  onAddDayNightClick?: (date: string, pharmacyId: number) => void;
  onChangeDayOnlyToDayNightClick?: (dutyAssignmentId: number, pharmacyId: number) => void;
  onChangeDayNightToDayOnlyClick?: (dutyAssignmentId: number, pharmacyId: number) => void;
  onMarkForGroupChangeClick?: (pharmacyId: number) => void;
  onCalendarChanged?: (pharmacyId: number) => void;
  onAddCircle?: (lat: number, long: number) => void;
  id?: number;
  date?: string;
  groupEditMode?: boolean;
  protections?: any;
  disableRightClick?: boolean;
  group?: Instance<typeof Group>;
  simpleCalendarStartYear?: number;
}

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export interface PharmacyMarkerState {
  isOpen: boolean;
  isPinned: boolean;
  showContextMenu: boolean;
  groupEditMode: boolean;
}

class PharmacyMarker extends React.Component<PharmacyMarkerProps, PharmacyMarkerState> {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      isPinned: false,
      showContextMenu: false,
      groupEditMode: this.props.groupEditMode ? this.props.groupEditMode! : false,
    };
  }

  handleToggle = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
    // if (this.props.onCalendarChanged) {
    //   this.props.onCalendarChanged(this.props.marker.pharmacyId);
    // }
  };

  handleTogglePinned = () => {
    this.setState({
      isPinned: !this.state.isPinned,
      isOpen: !this.state.isPinned,
    });
  };

  handleToggleContextMenu = () => {
    this.setState({ showContextMenu: !this.state.showContextMenu });
  };

  handleCloseContextMenu = () => {
    if (this.props.onCalendarChanged) {
      this.props.onCalendarChanged(this.props.marker.pharmacyId);
    }
  };

  onIconChanged = () => {
    /*
    <div style="width: 32px; height: 32px; overflow: hidden; position: absolute; left: 210px; top: -45px; z-index: -13;">
    <img alt="" src="/static/media/location-pin.4df3d9fd.svg" draggable="false" style="position: absolute; left: 0px; top: 0px; user-select: none; width: 32px; height: 32px; border: 0px; padding: 0px; margin: 0px; max-width: none;">
    </div>
    */
    //$('img[src="'+this.props.icon+'"]').
  };

  render() {
    const { id } = this.props;

    // let protections = '';
    // if (this.props.protections && this.props.protections.length>0) {
    //   this.props.protections.forEach((element) => {
    //     protections = protections.concat(element.endDate+'<br/>');
    //   })
    // }

    // console.log(protections);

    return (
      <>
        {id && (
          <Marker
            key={this.props.marker.pharmacyId}
            position={{ lat: Number(this.props.marker.latitude), lng: Number(this.props.marker.longitude) }}
            icon={this.props.icon}
            onIconChanged={this.onIconChanged}
            onClick={() => this.handleTogglePinned()}
            onRightClick={() => {
              if (!this.props.disableRightClick) this.handleToggleContextMenu();
            }}
            onMouseOver={() =>
              this.setState({
                isOpen: true,
              })
            }
            onMouseOut={() =>
              this.setState({
                isOpen: false,
              })
            }
            zIndex={this.props.zIndex}
          >
            {this.state.showContextMenu && (
              <InfoWindow options={{ maxWidth: 1200, minWidth: 1200 }} onCloseClick={this.handleCloseContextMenu}>
                <SimplePharmacyCalendar
                  id={'topCal'}
                  pharmacyId={this.props.marker.pharmacyId}
                  hideLegend={true}
                  synchronizedScrolling={false}
                  fly={this.props.simpleCalendarStartYear}
                  // onCalendarMove={this.onCalendarMove}
                  // onTypeChange={this.onTypeChange}
                  // selectedType={this.state.selectedType}
                  separateToolbox={true}
                  inMultiCalendar={false}
                />
              </InfoWindow>
            )}
            {(this.state.isOpen || this.state.isPinned) && (
              <InfoWindow onCloseClick={this.handleToggle} options={{ disableAutoPan: true }}>
                <div>
                  <div>
                    <DivLine>
                      <NavLink to={Page.PharmacyPage + '/' + this.props.marker.pharmacyId}>
                        <h3>
                          {!this.props.marker.isActive && '(Inactive) '} {this.props.marker.apbNumber} -{' '}
                          {this.props.marker.name} - {this.props.marker.phone}
                        </h3>
                      </NavLink>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </DivLine>
                  </div>
                  <DivLine>
                    {this.props.marker.address},&nbsp;{this.props.marker.zipCode}&nbsp;{this.props.marker.city}
                    <div style={{ textAlign: 'right' }}>
                      Lvl:{this.props.marker.level}&nbsp;&nbsp;Grp:
                      {this.props.group !== undefined ? this.props.group.name : ''}
                    </div>
                  </DivLine>
                  <DivLine>
                    {/* <div>test test {protections}</div> */}
                    {this.props.protections &&
                      this.props.protections.map((protection) => {
                        return (
                          <>
                            {moment(protection.endDate).format('DD/MM/YYYY') + '  ' + protection.range + 'm'}
                            <br />
                          </>
                        );
                      })}
                  </DivLine>
                  <div>
                    {this.props.onSelectionClick && (
                      <Button
                        onClick={() => {
                          this.props.onSelectionClick!(this.props.marker);
                          this.handleToggle();
                        }}
                        intent="primary"
                      >
                        {/* {this.state.selectButtonLabel} */}
                        <TranslatedMessage id={TLCode.GENERAL_Select} />
                      </Button>
                    )}
                    {this.props.onAddDayOnlyClick && this.props.isFree!(this.props.marker.pharmacyId) && (
                      <Button
                        style={{ marginLeft: '20px' }}
                        onClick={() => {
                          this.props.onAddDayOnlyClick!(this.props.date!, this.props.marker.pharmacyId);
                          this.handleCloseContextMenu();
                        }}
                        intent="danger"
                      >
                        + J
                      </Button>
                    )}
                    {this.props.onAddDayNightClick && this.props.isFree!(this.props.marker.pharmacyId) && (
                      <Button
                        style={{ marginLeft: '20px' }}
                        onClick={() => {
                          this.props.onAddDayNightClick!(this.props.date!, this.props.marker.pharmacyId);
                          this.handleCloseContextMenu();
                        }}
                        intent="danger"
                      >
                        + J+N
                      </Button>
                    )}
                    {this.props.onChangeDayOnlyToDayNightClick && this.props.isDayOnly!(this.props.marker.pharmacyId) && (
                      <Button
                        style={{ marginLeft: '20px' }}
                        onClick={() => {
                          this.props.onChangeDayOnlyToDayNightClick!(id!, this.props.marker.pharmacyId);
                          this.handleCloseContextMenu();
                        }}
                        intent="danger"
                      >
                        -&gt;&nbsp;J+N
                      </Button>
                    )}
                    {this.props.onUnassignClick && (
                      <Button
                        style={{ marginLeft: '20px' }}
                        onClick={() => {
                          this.props.onUnassignClick!(id!, this.props.marker.pharmacyId);
                        }}
                        intent="danger"
                        icon={IconNames.DELETE}
                      />
                    )}
                    {this.props.onChangeDayNightToDayOnlyClick &&
                      this.props.isDayAndNight!(this.props.marker.pharmacyId) && (
                        <Button
                          style={{ marginLeft: '20px' }}
                          onClick={() => {
                            this.props.onChangeDayNightToDayOnlyClick!(id!, this.props.marker.pharmacyId);
                            this.handleCloseContextMenu();
                          }}
                          intent="danger"
                        >
                          -&gt;&nbsp;J
                        </Button>
                      )}
                    {this.props.groupEditMode && this.props.onMarkForGroupChangeClick && (
                      <Button
                        style={{ marginLeft: '20px' }}
                        onClick={() => {
                          this.props.onMarkForGroupChangeClick!(this.props.marker.pharmacyId);
                          this.handleCloseContextMenu();
                        }}
                        intent="primary"
                      >
                        <TranslatedMessage id={TLCode.GENERAL_Mark} />
                      </Button>
                    )}
                  </div>
                  {this.props.onAddCircle && (
                    <DivLine
                      style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: '10px',
                      }}
                    >
                      <Button
                        style={{ fontSize: 12 }}
                        onClick={() => {
                          if (this.props.onAddCircle) {
                            this.props.onAddCircle(
                              Number(this.props.marker.latitude),
                              Number(this.props.marker.longitude),
                            );
                            this.handleTogglePinned();
                          }
                        }}
                      >
                        <TranslatedMessage id={TLCode.TRANSFER_AddCircleDialogTitle} />
                      </Button>
                    </DivLine>
                  )}
                </div>
              </InfoWindow>
            )}
          </Marker>
        )}
      </>
    );
  }
}

export default PharmacyMarker;
